import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReportPropertyDetailConstant } from '../../residential-property/residential-property-detail.constant';
import { ReportPropertyDetailService } from '../../residential-property/residential-property-detail.service';
import { SharedService } from 'src/app/common/services/shared.service';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { countryCode } from 'src/app/common/constants/common.contants';


@Component({
  selector: 'app-nearby-rentals-and-occupancy',
  templateUrl: './nearby-rentals-and-occupancy.component.html',
  styleUrls: ['./nearby-rentals-and-occupancy.component.scss']
})
export class NearbyRentalsAndOccupancyComponent {
   @Output() isEmpatyCheck: any = new EventEmitter();
  nearByRentalAndOccupancyLoading = false;
  nearByRentalAndOccupancy  = ReportPropertyDetailConstant.nearByRentalAndOccupancy;
  nearByRentalAndOccupancyData  = [];
  isSaudiCheck: boolean=false;

  constructor(public reportPropertyDetailService : ReportPropertyDetailService,
    private sharedService : SharedService
  ) { }
  @Input() propertyInfo: any;
  ngOnInit() {
     this.isSaudiCheck = this.sharedService.getStoreValue(GlobalContants.StoreKey.countryCode) === countryCode.saudi;
     if(this.isSaudiCheck){
        this.nearByRentalAndOccupancy  = ReportPropertyDetailConstant.nearByRentalAndOccupancySaudi;
     }else{
        this.nearByRentalAndOccupancy  = ReportPropertyDetailConstant.nearByRentalAndOccupancy;
     }
    
  }
  ngOnChanges() {
    this.sharedService.language$.subscribe({
      next : (res: any) => {
        this.getNearByRentalAndOccupancyData();
      },
      error : (err:any) => { }
    })
  }
  getNearByRentalAndOccupancyData() {
    this.reportPropertyDetailService.getNearByRentalAndOccupancy(this.reportPropertyDetailService.nearByRentalAndOccupancy).subscribe({
      next : (res:any) => {
        
        if(res.status == 200){
          this.isEmpatyCheck.emit(true);
          this.nearByRentalAndOccupancyData = res.data
        }else{
          this.isEmpatyCheck.emit(false);
        }
      },
      error : () => {
        this.isEmpatyCheck.emit(false);

      }
    })
  }
  downloadExcel(type:string) {
    this.reportPropertyDetailService.downloadRentalReport("property_details_residential_nearby_rentals_occupancy", 'residential', this.propertyInfo.property_uid, 'f');
  }
}
